import axios from 'axios';

export function getAllUsers() {
  return axios.get('/api/users');
}
